import { SnackbarProvider } from "notistack";
import { BrowserRouter as ReactRouter } from "react-router";

import { AppContextProvider } from "../context";
import { AppLoadingScreen } from "./AppLoadingScreen";
import { Layout } from "./Layout";
import { NotificationProvider } from "./NotificationProvider";
import { Router } from "./Router";
import { ThemeProvider } from "./ThemeProvider";

interface AppProps {}

export function App({}: AppProps) {
  return (
    <AppContextProvider>
      <ThemeProvider>
        <SnackbarProvider maxSnack={2}>
          <NotificationProvider />
          <AppLoadingScreen>
            <ReactRouter>
              <Layout>
                <Router />
              </Layout>
            </ReactRouter>
          </AppLoadingScreen>
        </SnackbarProvider>
      </ThemeProvider>
    </AppContextProvider>
  );
}
